import { ThemesDataResolver } from '@b2b/common/resolvers';
import { TicketConfigDataResolver } from '@b2b/common/resolvers/ticket-config-data.resolver';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ThemesControllerModule } from './controllers/ThemesController';

export const ThemesView = angular
  .module('acme.view.application.themes', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.auth',
    ThemesControllerModule,
    'acme.view.application.themes.donation',
    'acme.view.application.themes.donation.create',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.themes',
      url: '/themes',
      views: {
        'subview-main': {
          controller: 'ThemesController',
          templateUrl: 'views/application/views/themes/themes.tpl.html',
        },
      },
      data: {
        pageTitle: 'Theme',
        permissions: [
          'WL_THEME_CONFIG_VIEW',
          'WL_TICKET_CONFIG_VIEW',
          'WL_POS_CONFIG_VIEW',
          'WL_MEMBERSHIP_CONFIG_UPDATE',
          'WL_CUSTOM_SCRIPTS_UPDATE',
        ],
      },
      resolve: {
        ThemesData: ThemesDataResolver({ includeEmail: true }),
        TicketConfigData: TicketConfigDataResolver(),
      },
    });

    $stateProvider.state({
      name: 'application.themes.config',
      url: '/config',
      views: {
        'subview-main': {
          controller: 'ThemesController',
          templateUrl: 'views/application/views/themes/config.tpl.html',
        },
      },
    });

    $stateProvider.state({
      name: 'application.themes.web',
      url: '/config/web',
      views: {
        'subview-main': {
          controller: 'ThemesController',
          templateUrl: 'views/application/views/themes/detail.tpl.html',
        },
      },
      resolve: {
        ThemesData: ThemesDataResolver({ includeEmail: true }),
        TicketConfigData: TicketConfigDataResolver(),
      },
    });

    $stateProvider.state({
      name: 'application.themes.detail',
      url: '/config/:detail',
      views: {
        'subview-main': {
          controller: 'ThemesController',
          templateUrl: 'views/application/views/themes/detail.tpl.html',
        },
      },
      resolve: {
        ThemesData: ThemesDataResolver({ includeEmail: true }),
        TicketConfigData: TicketConfigDataResolver(),
      },
    });
  }).name;
